import React, { type FC } from 'react';
import styles from './saleIndicator.scss';
import { translate } from '#packages/i18n';
import { cx } from '#packages/util';

interface SaleIndicatorProps {
  isActive: boolean;
}

const SaleIndicator: FC<SaleIndicatorProps> = ({ isActive }) => {
  return (
    <div
      className={cx(styles.saleIndicator, {
        [styles.saleIndicator_active]: isActive,
      })}
    >
      {translate('Topbar_upgrade_sale_banner_text')}
    </div>
  );
};

export default SaleIndicator;
